interface MergeResponse {
  document: Record<string, unknown>;
  filename: string;
}

const baseApiUrl = process.env.REACT_APP_API_URL ?? "";
const apiUrl = `${baseApiUrl}/api/annotate/merge`;

export const mergeMetadata = async (
  file1: File,
  file2: File,
): Promise<MergeResponse> => {
  const formData = new FormData();
  // Historical field names; backend auto-detects general vs technical.
  formData.append("main_md", file1);
  formData.append("general_md", file2);

  const res = await fetch(apiUrl, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    let detail = res.statusText;
    try {
      const err = await res.json();
      if (err?.detail) detail = typeof err.detail === "string" ? err.detail : JSON.stringify(err.detail);
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }

  return await res.json();
};
